import { graphql, useStaticQuery } from 'gatsby'
import { useMemo } from 'react'
import { USER_EXPERIENCES } from '../constants'
import { useAuthContext } from '../context/AuthContext'
import { useCookies } from 'react-cookie'

export default function useDefaultPhoneNumberByExperience() {
  const data = useStaticQuery(graphql`
    query {
      contentstackContactUs {
        content_group {
          phone_number
          user_experience {
            experience
          }
        }
      }
    }
  `)

  const [cookies] = useCookies(['userExperience'])
  const auth = useAuthContext()
  const currentUserExperience = cookies?.userExperience ? cookies?.userExperience : auth?.state?.userExperience || USER_EXPERIENCES.UNATTESTED

  const phoneNumberMap = useMemo(
    () =>
      data.contentstackContactUs.content_group.reduce(
        (acc, { user_experience, phone_number }) => {
          acc[user_experience.experience] = phone_number
          return acc
        },
        {}
      ),
    [data]
  )

  if (!data?.contentstackContactUs?.content_group) {
    console.warn('useDefaultPhoneNumberByExperience query returned no data.')
    return '(800)-427-2677' // Fallback phone number
  }

  return phoneNumberMap[currentUserExperience] ?? '(800)-427-2677' // Fallback phone number
}
